// Shared helper: apply a visual "sim status" ring to a shape's node style.
// Called by every shape's `getNodeStyle()` after setting the base colors.
//
// Values of properties.simStatus:
//   'pass'    — ran ok & matched expected (when expected is set)
//   'ok'      — ran ok, no expected set
//   'fail'    — ran ok but mismatched expected
//   'error'   — threw during evaluation
//   'skipped' — not reached by the active scenario's trace
//   null/undefined — no sim has run, draw default

const SIM_COLORS = {
  pass:  { stroke: '#10b981', strokeWidth: 3 },
  ok:    { stroke: '#10b981', strokeWidth: 2.5 },
  fail:  { stroke: '#ef4444', strokeWidth: 3 },
  error: { stroke: '#ef4444', strokeWidth: 3, strokeDasharray: '4 3' },
  skipped: { strokeWidth: 1.5, opacity: 0.45 },
};

export function applySimStatusStyle(style, properties) {
  const status = properties && properties.simStatus;
  if (!status) return style;
  const tweak = SIM_COLORS[status];
  if (!tweak) return style;
  const out = { ...style, ...tweak };
  return out;
}
